/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import { Modal, Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { recoverUsersMFA } from '../Auth/store/Auth.action';
import { localStorageService } from '../../services/localStorage.service';
import { logOut } from '../../services/auth.service';

function ResetMFAModal(props) {
  const { show, title, toggle } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      currentPassword: '',
    },
  });
  const dispatch = useDispatch();
  const {
    UserDetails: {
      userInfo: { email },
    },
  } = useSelector((state) => state);
  const { t } = useTranslation('common');
  const DATA_FILLED = 'data-filled';
  const [mfaType, setMfaType] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    if (user) {
      const formattedMfaType = user?.mfaType?.replace(/[^a-zA-Z ]/g, ' ')?.replace(/\b\w/g, (c) => c.toUpperCase());
      setMfaType(formattedMfaType);
    }
  }, []);
  const passwordRegex = /^(?=.*[A-Z])(?=.*[^a-zA-Z]).+$/;

  /**
   * Best-effort sign-out and local-state cleanup after the MFA reset, then a
   * hard redirect to login: the session was just destroyed, so the 2FA screen
   * has no token to identify this account with and would bounce to login
   * anyway — signing in issues a fresh token and returns the user to setup.
   * @returns {Promise<void>} resolves as the browser navigates away.
   */
  const changeLocalstorageStatus = async () => {
    await logOut();
    localStorageService.remove('loggedInUserInfo');
    localStorageService.remove('previousStates');
    localStorageService.remove('PO_Filters');
    localStorageService.remove('planningFilter');
    localStorageService.remove('bottomUpFilter');
    localStorageService.remove('costingTodoListFilter');
    localStorageService.remove('sampleTodoListFilter');
    localStorageService.remove('indicatorTodoListFilter');
    localStorageService.remove('poTodoListFilter');
    localStorageService.remove('todo_po_selected_options');
    localStorageService.remove('submitTodoListFilter');
    localStorageService.remove('suggestionTodoListFilter');
    localStorageService.remove('productListFilter');
    localStorageService.remove('libraryBOMFilter');
    localStorageService.remove('rememberMe');
    window.location.assign(`${window.location.origin}/login`);
  };

  const onSubmit = async (val) => {
    const reqObj = { ...val, email, requestBy: 'user' };
    const res = await dispatch(recoverUsersMFA(reqObj, t));
    if (res) {
      changeLocalstorageStatus();
      toggle();
    }
  };

  return (
    <Modal
      size="lg"
      show={show}
      toggle={toggle}
      animation
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      className="common-custom-modal modal-medium"
    >
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Header className="modal-header-custom">
          <Modal.Title id="contained-modal-title-vcenter">
            <span className="confirm-title">{title}</span>
          </Modal.Title>
          <span className="icon-close cursor-pointer ml-auto" onClick={toggle} aria-label="close" type="button" />
        </Modal.Header>
        <Modal.Body>
          <div className="modal-inner-data">
            <Row className="">
              <Col md={12} sm={12}>
                <h2 className="f-16 mt-0 mb-0">
                  <span className="font-heavy">{t('MULTIFACTOR_TYPE.MFA_AUTH')}</span> :<span> {mfaType}</span>
                </h2>
              </Col>
            </Row>
            <Row className="mt-16">
              <Col md={6} sm={6}>
                <div className="common-input-control d-flex align-items-center mb-0 ">
                  <span className="fix-icons icon-lock mr-16" />
                  <div>
                    <p className="field-name mr-2 ">
                      {t('RESET_MFA_MODAL.CURRENT_PASSWORD')}
                      <span className="asterisk">*</span>
                    </p>
                    <Form.Control
                      className={watch('currentPassword') && DATA_FILLED}
                      {...register('currentPassword', {
                        required: t('RESET_MFA_MODAL.PASSWORD_REQUIRED'),
                        pattern: {
                          value: passwordRegex,
                          message: t('RESET_MFA_MODAL.PASSWORD_PATTERN'),
                        },
                      })}
                      type="password"
                      placeholder={t('COMMON_LABEL.ENTER_PASSWORD')}
                    />
                    {errors?.currentPassword?.message && <Form.Text className="text-danger">{errors?.currentPassword?.message}</Form.Text>}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <div className="common-model-footer">
            <button aria-label="tick" type="submit" className="btn p-0">
              <i className="icon-Tick-1 f-24" />
            </button>
          </div>
        </Modal.Body>
      </Form>
    </Modal>
  );
}

export default ResetMFAModal;
